import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const ModulesContext = createContext({ modules: {}, isVisible: () => true, refresh: () => {}, setModules: () => {} });

export function ModulesProvider({ children }) {
  const { user } = useAuth();
  const [modules, setModules] = useState({});
  const refresh = useCallback(
    () => api.get("/settings/modules").then((r) => setModules(r.data.visibility || {})).catch(() => {}),
    []
  );
  useEffect(() => { if (user) refresh(); }, [user, refresh]);
  const isVisible = useCallback((key) => modules[key] !== false, [modules]);
  return (
    <ModulesContext.Provider value={{ modules, isVisible, refresh, setModules }}>
      {children}
    </ModulesContext.Provider>
  );
}

export const useModules = () => useContext(ModulesContext);
